import HeroSlider from './HeroSlider';
export default HeroSlider;